export function getRoomTable() {
    return [
        {name: "咖啡厅", key: "coffee", location: "学生高层公寓一楼", individual: true, group: true},
        {name: "健身房（学生）", key: "gym", location: "学生高层公寓一楼", individual: false, group: false, gym: true},
        {name: "健身房（教职工）", key: "gymt", location: "学生高层公寓一楼", individual: false, group: false, gym: true,gymTeacher:true},
        {name: "面试室", key: "mensetu", location: "学生高层公寓一楼", individual: true, group: false, gym: false,gymTeacher:false,mensetu:true}
        // {name: "小型共享会议室", key: "l1", location: "学生高层公寓负一楼", individual: false, group: true},
        // {name: "团体心理辅导室", key: "l2", location: "学生高层公寓负一楼", individual: false, group: true},
        // {name: "多功能休息室", key: "l3", location: "学生高层公寓负一楼", individual: true, group: true},
        // {name: "叙事屋", key: "x1", location: "南方医院159栋A门旁", individual: false, group: true},
        // {name: "多媒体", key: "x2", location: "南方医院159栋A门旁", individual: false, group: true}
    ]
}


export function parseByKey(key) {
    for (let r of getRoomTable()) {
        if (r.key === key) return r
    }
    return {name: "房间未找到", key: "114514", location: "兰德索尔", individual: false, group: false}
}
